import axios from 'axios';
import nProgress from 'nprogress';

const apiBaseUrl = process.env.VUE_APP_ECOMMERCE_BASE_API;

/**
 * Axios basic configuration
 * Some general configuration can be added like timeout, headers, params etc. More details can be found on https://github.com/axios/axios
 * */
const baseConfig = {
  baseURL: apiBaseUrl,
};

/**
 * Creating the instance of Axios
 * It is because, in large scale application we may need to consume APIs from more than single server,
 * So, may need to create multiple http client with different config
 * Only this client will be used rather than axios in the application
 * */
const httpClient = axios.create(baseConfig);

/**
 * Auth interceptors
 * @description Configuration related to AUTH token can be done in interceptors.
 * Currently it is just doing nothing but idea to to show the capability of axios and its interceptors
 * In future, interceptors can be created into separate files and consumed into multiple http clients
 * @param {*} config
 */
const authInterceptor = (config) => {
  /** Add logging here */
  // eslint-disable-next-line no-param-reassign
  config.headers.common.Authorization = `Bearer ${localStorage.getItem('jwt_token')}`;
  return config;
};

const requestProgress = (config) => {
  nProgress.start();
  return config;
};

/** Adding the request interceptors */
httpClient.interceptors.request.use(authInterceptor);
httpClient.interceptors.request.use(requestProgress);

/** Adding the response interceptors */
httpClient.interceptors.response.use(
  (response) => {
    nProgress.done();
    return response.data.data || response.data;
  },
  (error) => {
    console.log(error);
    nProgress.done();
    /** Do something with response error */
    if (error.response.status === 401 || error.response.data.message === 'expired token' || error.response.data.message === 'User not Authorized' || error.response.data.message === 'E_INVALID_JWT_TOKEN: The Jwt token is invalid') {
      // Clear local storage of all tokens
      // Redirect to login page
      localStorage.removeItem('jwt_token');
      localStorage.removeItem('jwt_refresh_token');
      window.location = '/auth/login';
    }
    return Promise.reject(error.response.data);
  },
);

// eslint-disable-next-line import/prefer-default-export
export { httpClient };
